// extracted by mini-css-extract-plugin
export default {"JobsPage":"WorkWithUs_JobsPage__YKzBF","JobsTitleHolder":"WorkWithUs_JobsTitleHolder__ZiKyO"};